import { Card } from '@avanta/shared/components/ui/Card';
import { Skeleton } from '@avanta/shared/components/ui/Skeleton';

const CONTACT_IDS = ['email', 'nif', 'contactPhone'];
const RECORD_IDS = ['activeRecord', 'sickLeaveStart', 'lastSession'];

export const PatientSummarySkeleton = (): React.ReactElement => (
  <Card variant="primary" className="am-md:px-8 am-md:py-6" aria-busy="true">
    <div aria-hidden="true">
      <Skeleton className="h-6 w-64 max-w-full" />
      <div className="mt-4 flex justify-between gap-12">
        <div className="flex w-full flex-1 max-w-1/2 flex-col gap-3">
          {CONTACT_IDS.map(id => (
            <div key={id} className="flex items-center gap-2">
              <Skeleton className="size-4.5 shrink-0" />
              <Skeleton className="h-5 w-48 max-w-full" />
            </div>
          ))}
        </div>
        <div className="flex w-full flex-1 max-w-1/2 flex-col gap-3">
          {RECORD_IDS.map((id, index) => (
            <div key={id} className="flex items-center gap-2">
              <div className="w-30 shrink-0">
                <Skeleton className="h-4 w-24" />
              </div>
              <Skeleton className={index === 0 ? 'h-6 w-24' : 'h-5 w-32'} />
            </div>
          ))}
        </div>
      </div>
    </div>
  </Card>
);
